<template>
  <div>
    <pack-info :showMenu="true"></pack-info>
    <v-container fluid>
      <div column class="och-topMargin--packInfoOffset">
        <h1 class="title font-weight-thin mb-3 ml-1">Account Manager Dashboard</h1>
        <v-card class="elevation-0">
          <v-tabs v-model="active">
            <v-tab key="my" ripple data-cy="myServiceAreas">My Service Areas</v-tab>
            <v-tab key="all" ripple data-cy="all-service-areas">All Service Areas</v-tab>

            <v-tab-item key="my">
              <service-area-my></service-area-my>
            </v-tab-item>

            <v-tab-item key="all">
              <service-area-all></service-area-all>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import PackInfo from "@/components/packInfo";

import ServiceAreaAll from "./ServiceAreaAll";
import ServiceAreaMy from "./ServiceAreaMy";

export default {
  components: {
    PackInfo,
    ServiceAreaAll,
    ServiceAreaMy,
  },
  computed: {
    theme() {
      return this.$store.state.session.theme;
    },
  },
  data() {
    return {
      active: null,
    };
  },
  async created() {
    await this.loadDashboard();
  },
  methods: {
    async loadDashboard() {
      const {
        $route: {
          params: { packId },
        },
      } = this;

      await this.loadServiceAreaList(packId);
    },
    ...mapActions({
      loadServiceAreaList: "dashboard/serviceArea/load",
    }),
  },
  watch: {
    $route: "loadDashboard",
  },
};
</script>
